import { useTrackerContext } from "core/state/TrackerContext/TrackerContext";
import { TrackerType } from "core/state/Trackers/TrackerType";
import { TrackerChart } from "../../components/Trackers/Charts/TrackerChart";
import { ChartDayOffsets } from "../../components/Trackers/Charts/helpers";
import { useEffect, useState } from "react";
import { useGetUserTrackerValuesFunctionRequest } from "shared/request/myHealthyAdvantageApi";
import { t } from "i18next";

export const GeneralActivityTrackerChart = () => {
  const today = new Date();
  const [dateFrom, setDateFrom] = useState<Date>(today.addDays(ChartDayOffsets.week));
  const { getCurrentTrackerValue } = useTrackerContext();
  const {
    data: activityTrackerData,
    mutate,
    isLoading,
    error,
  } = useGetUserTrackerValuesFunctionRequest({
    from: dateFrom.toDateOnlyString(),
    to: today.toDateOnlyString(),
    trackerType: TrackerType[TrackerType.Activity],
  });

  useEffect(() => {
    mutate();
  }, [getCurrentTrackerValue, mutate]);

  return (
    <TrackerChart
      trackerType={TrackerType[TrackerType.Activity]}
      heading={t("wellbeing.trackers.activity.chart.heading")}
      dateRange={{ startDate: dateFrom, endDate: today }}
      yAxisStepSize={5}
      yAxisLabel={t("wellbeing.trackers.activity.chart.yLabel")}
      loading={isLoading}
      showError={error !== undefined}
      data={activityTrackerData?.values ?? []}
      reload={() => mutate()}
      onChartViewOffsetChange={(offset) => setDateFrom(today.addDays(offset))}
      initialChartViewOffset={ChartDayOffsets.week}
    />
  );
};
